/**************************************************
 * Nombre:       Nosotros_Inicios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import nos from '../../../Recursos/inicios2.png'
import nos2 from '../../../Recursos/inicios1.png'
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Nosotros_Inicios = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}

            >

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}

                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize:  30,
                                color: theme.palette.primary.main
                            }}>NUESTROS
                                INICIOS</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 10}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: sCell ? 2 : 0}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, textAlign: sCell ? 'center' : 'left'}}>
                                En aquella ciudad donde el frio despierta el alma nace Quesuditas en el 2012, una marca
                                que cuenta su historia desde un bocado autentico lleno de pasión e innovación, donde
                                todo propósito se saborea; porque aquí las ideas se construyen para convertirse en en
                                sueños cumplidos.
                                <br/>
                                <br/>
                                Anhelamos con ser los primeros en Ipiales en llevar una marca local a Nivel nacional con
                                la plena convicción de que podemos crecer. Apostamos por lo que hacemos; productos
                                cuidadosamente elaborados, frescos y llenos de calidad humana, hechos para convertirlos
                                en una leyenda.
                            </Typography>
                        </Grid>


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', mr: -8, zIndex: 2, mb: -8, mt: sCell ? 4 : 0}}>
                            <img src={nos2} width={'100%'} height={'auto'} style={{borderRadius: 20}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', zIndex: 1, mt: sCell ? 12 : 0}}>
                            <img src={nos} width={'100%'} height={'auto'} style={{borderRadius: 20}}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Inicios